export { default as commonTitle } from "./commonTitle";